import { AlertTriangle } from 'lucide-react';
import { cardBase, fmtDate, ViewAllLink } from './dashboardUtils';

export function VacanciesWidget({ vacancies }) {
  return (
    <div className={`${cardBase} overflow-hidden`}>
      <div className="flex items-center justify-between px-6 pt-5 pb-3">
        <h2 className="text-[15px] font-semibold text-gray-900 flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-amber-400" /> Upcoming Vacancies
        </h2>
        <ViewAllLink to="/vacancy?tab=all" label="vacancies" />
      </div>
      <div className="px-6 pb-5">
        {vacancies.length === 0 ? (
          <p className="text-[13px] text-gray-400 py-2">No upcoming vacancies</p>
        ) : (
          <div className="space-y-0">
            {vacancies.map((v, i) => {
              const days = v.vacancy_end ? Math.round((new Date(v.vacancy_end) - new Date(v.vacancy_start)) / 86400000) : null;
              return (
                <div key={i} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
                  <div>
                    <p className="text-[13px] font-medium text-gray-900">{v.property_name} Unit {v.unit_number}</p>
                    <p className="text-[11px] text-gray-400 tabular-nums mt-0.5">{fmtDate(v.vacancy_start)}</p>
                  </div>
                  {v.has_future_tenant ? (
                    <span className="text-[11px] font-medium text-gray-500 bg-gray-100 rounded-full px-2.5 py-0.5 tabular-nums">{days}d</span>
                  ) : (
                    <span className="inline-flex items-center gap-1 text-[11px] font-medium text-amber-700 bg-amber-50 rounded-full px-2.5 py-0.5">
                      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />Open
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
